// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const ACCOUNT_QUERY = gql`
  query AccountHome {
    org {
      name
      updated_at
      created_at
      free_trial_started_at
      subscription_tier
      subscription_status
      timezone
      users {
        edges {
          node {
            id
            firstname
            lastname
            created_at
            permissions {
              can_edit_orders
              can_edit_crops_blends
              can_edit_tasks
              can_edit_plantings
              can_complete_tasks
            }
          }
        }
      }
    }
    user_invites {
      edges {
        node {
          id
          email_sent_to
          name
          status
          created_at
        }
      }
    }
    user {
      email
      firstname
      lastname
      created_at
      is_admin
      allows_email_updates
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout(input: { placeholder: 1 }) {
      success
    }
  }
`;
